import {
    GET_QA_TEMPLATES, QA_TEMPLATES_ERROR,
    INSPECTION_DASHBOARD_DOCUMENT_ERROR,
} from '../type'
// import axios from 'axios';
import env from '../../ENV';
import AxiosHandler from '../../Classes/AxiosHandler';
let ROOT_URL = env.BACKEND_URL;

export const getQATemplates = () => async dispatch => {

    try {
        const res = await AxiosHandler.get(`${ROOT_URL}qa-templates`);//await axios.get(`${ROOT_URL}qa-templates`)
        dispatch({
            type: GET_QA_TEMPLATES,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: QA_TEMPLATES_ERROR,
            payload: console.log(e),
        })
    }

}

export const inspectionDashboardDocument = (form) => async dispatch => {
    // console.log(form,'from')

    // const lineid = form.DocumentId

    try {
        // const res = await axios.post(`${INSPECTION_DOC_URL}po/${id}/lineitems/${lineid}`)
        // dispatch( {
        //     type: INSPECTION_DASHBOARD_DOCUMENT_ERROR,
        //     payload: res.data
        // })
        //console.log(res.data,'from')  
    }
    catch (e) {
        dispatch({
            type: INSPECTION_DASHBOARD_DOCUMENT_ERROR,
            payload: console.log(e),
        })
    }

}
